module.exports = __webpack_public_path__ + "img/grb_bled_120_120.444d3961.png";